/**
 * useMyShowsPrefsStore — per-device preference for the "my shows" surfaces
 * (localStorage via Zustand persist, same pattern as useNavPrefsStore).
 *
 * The toggle lives on the My Schedule page. The dashboard's My Upcoming Shows
 * module has no control of its own and simply follows this setting.
 */
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface MyShowsPrefsState {
  hidePending: boolean;
  setHidePending: (v: boolean) => void;
}

const useMyShowsPrefsStore = create<MyShowsPrefsState>()(
  persist(
    (set) => ({
      hidePending: false,
      setHidePending: (v) => set({ hidePending: !!v }),
    }),
    { name: 'firefleet.my-shows-prefs', version: 0, storage: createJSONStorage(() => localStorage) },
  ),
);

export default useMyShowsPrefsStore;
